import type { StartMethod } from './conversation';
import { startMethodSchema } from './conversation';
import { objectSchemaOf, Joi, actionCreator } from '../helpers';
import { DIALOGUE_OUTPUT } from './topics';

export const STARTED = 'DIALOGUE/STARTED';

export interface IStartedPayload {
  conversationId: string;
  organisationId: string;
  consoleId: string;
  startedOn: number;
  startMethod?: StartMethod;
  snapshotId?: string;
  faceId?: string;
}

export const startedPayloadSchema = objectSchemaOf<IStartedPayload>({
  conversationId: Joi.string().required(),
  organisationId: Joi.string().required(),
  consoleId: Joi.string().required(),
  startedOn: Joi.number().required(),
  startMethod: startMethodSchema.optional(),
  snapshotId: Joi.string().optional(),
  faceId: Joi.string().optional(),
});

export interface IStartedAction {
  type: typeof STARTED;
  payload: IStartedPayload;
}

export const startedActionSchema = objectSchemaOf<IStartedAction>({
  type: Joi.string().valid(STARTED).required(),
  payload: startedPayloadSchema.required(),
});

export const started = actionCreator({
  type: STARTED,
  schema: startedActionSchema,
  topic: DIALOGUE_OUTPUT,
});
